module.exports = __webpack_public_path__ + "static/react-npm-stats-a54f31e865c54b9aea821855377631f3.png";